import { LOCATION } from '../utils/common';
import { Events, FluxCapacitor } from 'groupby-api';

export class Redirect {

  constructor(private flux: FluxCapacitor) { }

  init() {
    this.flux.on(Events.REDIRECT, (redirect) => LOCATION.assign(redirect));
  }
}



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/services/redirect.ts
 **/